import React from "react";
import { FormControl, FormLabel } from "@chakra-ui/form-control";
import { Controller, ControllerProps } from "react-hook-form";
import { ObservatoryBundleFields, formContext } from "./Form";

interface SelectControlProps {
  name: keyof ObservatoryBundleFields;
  label: string;
  children: React.ReactElement;
}

export interface Option {
  value: string;
  label: string;
}

export type SelectOnChangeHandlerFn = (option: Option) => void;

export const SelectController = (props: SelectControlProps) => {
  const { label, name, children } = props;

  const { control } = React.useContext(formContext);

  if (!control) {
    throw new Error("SelectController must be a child of Form");
  }

  if (!children) {
    throw new Error("SelectController requires children");
  }

  const renderChildrenWithOnChange: ControllerProps<ObservatoryBundleFields>["render"] =
    ({ field: { onChange, value } }) =>
      React.cloneElement(children, {
        value: value,
        onChange: (option: Option) => onChange(option),
      });

  return (
    <FormControl mb="4">
      <FormLabel>{label}</FormLabel>
      <Controller
        control={control}
        name={name}
        render={renderChildrenWithOnChange}
      />
    </FormControl>
  );
};
